var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-container power-box"
    },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "用户群组管理", url: "/system/usergroup" },
                { label: _vm.headerName, url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c("div", { ref: "table", staticClass: "power-table" }, [
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "addForm",
                attrs: {
                  "label-position": "top",
                  "label-width": "80px",
                  model: _vm.group,
                  rules: _vm.rules
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "用户群组名称", prop: "userGroupName" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "text",
                        placeholder: "请输入用户群组名称",
                        maxlength: "50",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.group.userGroupName,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "userGroupName", $$v)
                        },
                        expression: "group.userGroupName"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户群组描述", prop: "groupDescribe" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        placeholder: "请输入用户群组描述",
                        maxlength: "500",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.group.groupDescribe,
                        callback: function($$v) {
                          _vm.$set(_vm.group, "groupDescribe", $$v)
                        },
                        expression: "group.groupDescribe"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between"
                }
              },
              [
                _vm._m(0),
                _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                  _c("input", {
                    staticClass: "btn btn-red add-btn",
                    attrs: { type: "button", value: "新增" },
                    on: {
                      click: function($event) {
                        _vm.visible = true
                      }
                    }
                  }),
                  _c("input", {
                    staticClass: "btn btn-red add-btn",
                    staticStyle: { "margin-left": "20px" },
                    attrs: { type: "button", value: "按机构新增" },
                    on: {
                      click: function($event) {
                        _vm.isShow = true
                      }
                    }
                  })
                ])
              ]
            ),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.userList,
                  "highlight-current-row": "",
                  "tooltip-effect": "dark",
                  height: _vm.tableheight,
                  border: "",
                  "row-key": "userId"
                }
              },
              [
                _c("template", { slot: "empty" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center"
                      }
                    },
                    [
                      _c("no-data", {
                        attrs: { height: "400px", width: "400px" }
                      })
                    ],
                    1
                  )
                ]),
                _c("el-table-column", {
                  attrs: {
                    prop: "systemName",
                    label: "人员",
                    "min-width": "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(
                                      scope.row.userName +
                                        "/" +
                                        scope.row.userId
                                    )
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(
                                  _vm._s(
                                    scope.row.userName + "/" + scope.row.userId
                                  )
                                )
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "permissionId",
                    label: "所在部门",
                    "min-width": "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(scope.row.pathName)
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(_vm._s(scope.row.pathName))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "160", fixed: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "op-tips" },
                            [
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: { title: "确定删除此用户吗？" },
                                  on: {
                                    onConfirm: function($event) {
                                      return _vm.deleteUser(scope.$index)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "op-item",
                                      staticStyle: {
                                        color: "var(--mainColor)",
                                        cursor: "pointer"
                                      },
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v(" 删除 ")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              2
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          ref: "footer",
          staticStyle: {
            position: "sticky",
            bottom: "0",
            left: "0",
            right: "0",
            "background-color": "#fff",
            "border-top": "1px solid #ebeef5",
            "z-index": "100"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "right", padding: "10px" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.back()
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增成员",
            visible: _vm.visible,
            width: "550px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "adduser-label-box" }, [
              _c(
                "label",
                {
                  staticClass: "adduser-label",
                  staticStyle: { width: "120px", color: "#333" }
                },
                [
                  _vm._v(" 成员列表： "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#999",
                        "font-weight": "100"
                      }
                    },
                    [
                      _vm._v(
                        " 书写格式为“用户编号”或者“姓名/用户编号”，多个成员之间换行隔开 "
                      )
                    ]
                  )
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "adduser-error-box" },
              _vm._l(_vm.adduserErrorList, function(item) {
                return _c(
                  "p",
                  { key: item, staticClass: "adduser-error-text" },
                  [_vm._v(" " + _vm._s(item) + " ")]
                )
              }),
              0
            ),
            _c(
              "p",
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 12,
                    placeholder: "请输入内容"
                  },
                  model: {
                    value: _vm.edituserValue,
                    callback: function($$v) {
                      _vm.edituserValue = $$v
                    },
                    expression: "edituserValue"
                  }
                })
              ],
              1
            ),
            _c(
              "p",
              {
                staticStyle: {
                  "text-align": "center",
                  "margin-bottom": "0",
                  "margin-top": "20px"
                }
              },
              [
                _c("input", {
                  staticClass: "btn",
                  attrs: { type: "button", value: "取消" },
                  on: {
                    click: function($event) {
                      _vm.visible = false
                    }
                  }
                }),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "20px" },
                    attrs: { type: "primary", loading: _vm.loading },
                    on: {
                      click: function($event) {
                        return _vm.addUsers()
                      }
                    }
                  },
                  [_vm._v(" 确认 ")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm.isShow
        ? _c(
            "div",
            [
              _c("user-select-dialog", {
                attrs: {
                  multiple: "multiple",
                  modal: true,
                  modalAppendToBody: false,
                  rootOrgIds: _vm.rootOrgId,
                  appendToBody: true,
                  "user-dialog-visible": _vm.isShow
                },
                on: {
                  confirm: _vm.addUsersByOrg,
                  cancle: function($event) {
                    _vm.isShow = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c(
          "span",
          {
            staticStyle: {
              color: "#f5222d",
              "font-size": "14px",
              "font-family": "SimSun, sans-serif"
            }
          },
          [_vm._v(" * ")]
        ),
        _vm._v(" 成员列表 ")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }